export default "__VITE_PUBLIC_ASSET__fa1b15ff__"